<template>
    <zk-admin-table title="精准关怀体检收费" :loading="loading" :table="table" @change="handleTableChange">
        <template v-slot:buttons>
            <el-row style="float: right">
                <el-button type="default" size="small" @click="getData" icon="el-icon-refresh">刷新</el-button>
            </el-row>
        </template>

        <template v-slot:search>
            <zk-search-form-inline :form="search" @search="getData">
                <el-form-item label="姓名">
                    <el-input v-model.trim="search.name" clearable style="width:120px"></el-input>
                </el-form-item>
                <el-form-item label="身份证号">
                    <el-input v-model.trim="search.id_card" clearable></el-input>
                </el-form-item>
                <el-form-item label="状态">
                     <el-select v-model="search.status" placeholder="全部" clearable style="width:120px">
                        <el-option label="已申请" value="0"></el-option>
                        <el-option label="已审核" value="1"></el-option>
                        <el-option label="审核不通过" value="-1"></el-option>
                        <el-option label="已收费" value="2"></el-option>
                        <el-option label="已报告" value="3"></el-option>
                    </el-select>
                </el-form-item>
            </zk-search-form-inline>
        </template>

        <el-table-column type="index" width="50" align="center" />
        <el-table-column prop="secondary_unit" label="二级单位" width="150" align="center" />
        <el-table-column prop="name" label="姓名" width="100" align="center" />
        <el-table-column prop="id_card" label="身份证号" width="170" align="center" />
        <el-table-column prop="status" label="状态" width="100" align="center">
            <template slot-scope="scope">
                <el-tag v-if="scope.row.status == 0" type="primary" size="mini">已申请</el-tag>
                <el-tag v-else-if="scope.row.status == 1" type="success" size="mini">已审核</el-tag>
                <el-tag v-else-if="scope.row.status == -1" type="danger" size="mini">审核不通过</el-tag>
                <el-tag v-else-if="scope.row.status == 2" type="warning" size="mini">已收费</el-tag>
                <el-tag v-else-if="scope.row.status == 3" type="success" size="mini">已报告</el-tag>
            </template>
        </el-table-column>
        <el-table-column prop="items" label="检查项目" align="center">
            <template slot-scope="scope">
                <el-tag v-for="(item, index) in scope.row.items" :key="index" size="mini" style="margin-right: 5px;">{{ item }}</el-tag>
            </template>
        </el-table-column>
        <el-table-column prop="total_cost" label="费用合计" width="100" align="center">
            <template slot-scope="scope">
                {{ scope.row.total_cost }} 元
            </template>
        </el-table-column>
        <el-table-column prop="create_time" label="申请时间" width="160" align="center" />
        <el-table-column prop="applicant" label="申请人" width="100" align="center" />
        
        <el-table-column align="center" width="120" label="操作" fixed="right">
            <template slot-scope="scope">
                <!-- <el-button size="mini" type="primary" @click="handleFee(scope.row)" v-if="scope.row.status === 3">收费</el-button> -->
                <el-button size="mini" type="primary" @click="handleFee(scope.row)" v-if="scope.row.status === 2">退费</el-button>
                <el-button size="mini" @click="handleFee(scope.row)" v-else>查看</el-button>
            </template>
        </el-table-column>

        <template v-slot:dialog>
            <el-dialog title="体检收费" :visible.sync="dialogVisible" width="60%" :close-on-click-modal="false">
                <el-form ref="form" :model="form" label-width="100px" disabled>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="姓名" prop="name">
                                <el-input v-model.trim="form.name"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="身份证号" prop="id_card">
                                <el-input v-model.trim="form.id_card"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="二级单位" prop="secondary_unit">
                                <el-input v-model.trim="form.secondary_unit"></el-input>
                            </el-form-item>
                        </el-col>
                         <el-col :span="12">
                             <el-form-item label="费用合计">
                                <span style="color: red; font-weight: bold; font-size: 16px;">{{ form.total_cost }} 元</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="检查项目" prop="items">
                                <el-tag v-for="(item, index) in form.items" :key="index" style="margin-right: 10px;">{{ item }}</el-tag>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="报告" prop="remark">
                                <a :href="form.report_url" target="_blank">查看报告</a>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <span slot="footer" class="dialog-footer" v-if="[2, 3].includes(form.status)">
                    <el-button @click="handleRefund">取消收费</el-button>
                    <el-button type="primary" @click="handleSubmit" :loading="loading">确认收费</el-button>
                </span>
                <span slot="footer" class="dialog-footer" v-else>
                     <el-button @click="dialogVisible = false">关 闭</el-button>
                </span>
            </el-dialog>
        </template>
    </zk-admin-table>
</template>

<script>
export default {
    name: 'keycare_fee',
    path: '/main/keycare/fee',
    meta: {
        title: '精准关怀体检收费',
    },
    data() {
        return {
            loading: false,
            dialogVisible: false,
            search: {
                name: '',
                id_card: '',
                status: '3' // Default to audited (pending payment)
            },
            table: {
                columns: [],
                data: [],
                total: 0,
                page: 1,
                pageSize: 20
            },
            form: {
                name: '',
                id_card: '',
                secondary_unit: '',
                items: [],
                total_cost: 0,
                status: 0
            }
        }
    },
    methods: {
        handleTableChange(e) {
            this.table = Object.assign({}, this.table, e);
            this.getData();
        },
        async getData() {
            this.loading = true;
            this.loading = true;
            try {
                const resp = await this.$http.get('/keycare/register', {
                    params: {
                        page: this.table.page,
                        pageSize: this.table.pageSize,
                        ...this.search
                    }
                });
                this.table.data = resp.data.data;
                this.table.total = resp.data.total;
            } catch (e) {
                this.$message.error(e.message || '获取数据失败');
            }
            this.loading = false;
        },
        handleFee(row) {
            this.form = JSON.parse(JSON.stringify(row));
            this.dialogVisible = true;
        },
        async handleRefund() {
            this.loading = true;
            try {
                // Mock fee submission
                await this.$http.post('/keycare/fee', { id: this.form.id, status: 0 });
                
                // await new Promise(resolve => setTimeout(resolve, 500)); 
                this.$message.success('收费成功');
                this.dialogVisible = false;
                this.getData();
            } catch (e) {
                this.$message.error(e.message || '操作失败');
            }
            this.loading = false;
        },
        async handleSubmit() {
            this.loading = true;
            try {
                // Mock fee submission
                await this.$http.post('/keycare/fee', { id: this.form.id, status: 2 });
                
                // await new Promise(resolve => setTimeout(resolve, 500)); 
                this.$message.success('收费成功');
                this.dialogVisible = false;
                this.getData();
            } catch (e) {
                this.$message.error(e.message || '操作失败');
            }
            this.loading = false;
        }
    },
    mounted() {
        this.getData();
    }
}
</script>

<style lang="scss" scoped>
</style>
